export default __webpack_public_path__ + "static/media/soccer.b110065a.gif";